import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import moment from 'moment';
import { PromptDialogComponent } from '../../../../shared/component/prompt-dialog/prompt-dialog.component';
import { DatePipe } from '@angular/common';
import { HolidaysService } from '../services/holidays.service';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
import { SpinnerComponent } from '../../../../shared/component/spinner/spinner.component';
import { dateValidator } from '../../../../shared/custom-validator/date-validator';
import { noWhitespaceValidator } from '../../../../shared/custom-validator/white-space-validator';
import { TimeConversionService } from '../../../../shared/service/time-conversion.service';
import { UserLocationService } from 'src/app/shared/service/user-location.service';
import { skip } from 'rxjs';
import { atLeastOneDayValidator } from 'src/app/shared/custom-validator/atleast-one-field';
import { PlanningDataService } from 'src/app/shared/service/planning-data.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

type HolidayFormValue = {
  name: string | null;
  holidayType: any;
  startDate: string | null;
  endDate: string | null;
  startTime: string | null;
  endTime: string | null;
};

@Component({
  selector: 'app-create-holiday',
  templateUrl: './create-holiday.component.html',
  styleUrl: './create-holiday.component.scss',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class CreateHolidayComponent implements OnInit {
  createHolidaysForm = this._formBuilder.group({
    name: ['', [Validators.required, noWhitespaceValidator()]],
    holidayType: '',
    startDate: ['', [Validators.required, dateValidator()]],
    endDate: ['', [Validators.required, dateValidator()]],
  }, { validators: atLeastOneDayValidator() });
  holidays = [
    { value: 'Christmas', viewValue: 'Christmas' },
    { value: 'Onam', viewValue: 'Onam' },
    { value: 'Easter', viewValue: 'Easter' },
  ];
  currentDate: any = new Date();
  minEndDate: any;
  // maxEndDate: any = new Date();
  maxStartDate: Date = new Date(this.currentDate.getFullYear() + 2, this.currentDate.getMonth(), this.currentDate.getDate());
  maxEndDate: Date = new Date(this.maxStartDate.getFullYear() + 2, this.maxStartDate.getMonth(), this.maxStartDate.getDate());
  saveButtonEnable: boolean = false;
  holidayControl: any;
  startDateControl: any;
  startTimeControl: any;
  endDateControl: any;
  endTimeControl: any;
  availabilityControl: any;
  initialFormValue: HolidayFormValue;
  showWarningMessage: boolean = false;
  formattedStartDate: any;
  formattedEndDate: any;
  formattedStartTime: any;
  formattedEndTime: any;
  duplicateError: boolean = false;
  showEditForm: boolean = false;
  date: Date = new Date();
  selected: any;
  selectedDate: any;
  selectedEndDate: any;
  startAtDate: any;
  endAtDate: any;
  dateError: boolean = false;
  existingData: any;
  formattedYear: any;
  timeError: boolean = false;
  isAvailable: boolean = true;
  locationId : string | null
  currentLang:string
  changeEndDate:boolean = false
  editStartDate:any
  editEndDate:any
  isSaveDisabled: boolean = true;
  editMode :boolean =  false;
  isFormModified: boolean = false;
  startDate:any
  endDate:any
  editStartDateValue: any;
  editEndDateValue: any;
  changeStart: boolean;
  changeEnd: boolean;
  constructor(
    private dialogRef: MatDialogRef<CreateHolidayComponent>,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    public holidayService: HolidaysService,
    @Inject(MAT_DIALOG_DATA) public editFormData: any,
    public sharedDataService: SharedDataService,
    private timeConvertionService: TimeConversionService,
    private _userLocations: UserLocationService,
    private planningDataService: PlanningDataService
  ) {}
  ngOnInit(): void {
    this.existingData = this.editFormData.initialTableData;
    this.locationId = this._userLocations.getSelLocationId()
    this.currentLang = this.editFormData.currentLanguage
    if (this.editFormData.editData) {
      this.editStartDate = this.editFormData.editData.startDate
      this.editEndDate = this.editFormData.editData.endDate
      this.showEditForm = true;
      this.editMode = true;
      this.editForm();
    } else {
      this.saveButtonEnable = true;
      this.initialFormValue = this.createHolidaysForm.getRawValue() as HolidayFormValue;
      this.editMode = false;
    }
   
    this.createHolidaysForm.valueChanges
      .pipe(skip(4)) // ⬅️ skip the first emission on initial load 
      .subscribe(values => {
        this.isFormModified = this.checkFormModified();
        this.checkIfSaveShouldBeDisabled();
    });
  }

  selectedStartDate(startDate: any){
    this.startDate = startDate
    this.createHolidaysForm.get('startDate')?.setValue(startDate.date);
    if(startDate.valid){
      const newDate = startDate.date;
      this.minEndDate = this.convertToDateString(startDate.date);
      if (!this.changeStart && this.editStartDateValue === newDate) { this.isSaveDisabled = true; }
      // this.createHolidaysForm.get('startDate')?.setValue(startDate.date);
    }
    else{
      this.createHolidaysForm.get('startDate')?.setErrors({invalid:true})
    }
    this.changeStart = true;
  }

  selEndDate(endDate: any){
    this.endDate = endDate
    this.createHolidaysForm.get('endDate')?.setValue(endDate.date);
    const currentValue = this.createHolidaysForm.getRawValue();

    this.isFormModified = JSON.stringify(currentValue) !== JSON.stringify(this.initialFormValue);
      // this.createHolidaysForm.get('endDate')?.setValue(endDate.date);

    if (endDate.valid) {
       const newDate = endDate.date;      
        if(this.isFormModified) {
           this.createHolidaysForm.markAsDirty();
        }
      if (!this.changeEnd && this.editEndDateValue === newDate){this.isSaveDisabled=true; return;}
      
    } 
    else {
      this.createHolidaysForm.get('endDate')?.setErrors({ invalid: true });
    }
    this.changeEnd = true;
  }

  convertToDateString(dateString: string) {
    const [day, month, year] = dateString?.split('.')?.map(Number);
    const date = new Date(year, month - 1, day);
    return date;
  }

  /** True when the string is a real calendar date (rejects impossible dates like 31.09.2025). */
  isRealDate(value: string): boolean {
    return moment((value || '').trim(), ['DD.MM.YYYY', 'D.M.YYYY'], true).isValid();
  }

  createHoliday() {
    this.formattedStartDate = this.createHolidaysForm?.get('startDate')?.value;
    let startYear = moment(
      this.createHolidaysForm?.get('startDate')?.value,
      'DD.MM.YYYY'
    )?.year();
    this.formattedEndDate = this.createHolidaysForm.get('endDate')?.value;
    let startDate = moment(
      this.createHolidaysForm.value.startDate,
      'DD.MM.YYYY'
    );
    let endDate = moment(this.createHolidaysForm.value.endDate, 'DD.MM.YYYY');
    if (startDate.isSameOrBefore(endDate)) {
      this.dateError = false;
    } else {
      this.dateError = true;
    }
    this.formattedYear = this.extractYear(this.formattedStartDate);
    if (this.showEditForm) {
      this.existingData?.forEach((yearItem: any) => {
        yearItem.items = yearItem?.items?.filter(
          (item: any) =>
            item?.holidayId !== this.editFormData?.editData?.holidayId
        );
      });
    }
    this.holidayAddDuplication();
  }

  extractYear(dateValue: any) {
    const dateObject = moment(dateValue, 'DD.MM.YYYY');
    // Extract year
    const year = dateObject.year();
    return year;
  }

  holidayAddDuplication() {
    for (const innerArray of this.existingData) {
      for (let item of innerArray.items) {
        if (
          this.createHolidaysForm.value.name?.toLowerCase() ===
          item.name.toLowerCase()
        ) {
          let itemYear = this.extractYear(item.startDate);
          if (itemYear === this.formattedYear) {
            this.duplicateError = true;
            break;
          } else {
            this.duplicateError = false;
          }
        } else {
          this.duplicateError = false;
        }
      }
      if (this.duplicateError) {
        break;
      }
    }
    if (!this.duplicateError && !this.dateError && !this.timeError) {
      this.callHolidaySaveApi();
    }
  }

  callHolidaySaveApi() {
    let saveApiData;
    saveApiData = {
      name: this.createHolidaysForm.value.name,
      startDate: this.createHolidaysForm.value.startDate,
      endDate: this.createHolidaysForm.value.endDate,
      isAvailable: this.isAvailable,
      holidayDuration: this.createHolidaysForm.value.holidayType,
      locationId: this.locationId,
    };
    let planDate = this.planningDataService.getDateData()
    let comparePlanDate = this.sharedDataService.compareWithPlanDate(saveApiData?.endDate, planDate)
    if (this.editFormData.buttonName === 'Create') {
      const addSpinnerRef = this.dialog.open(SpinnerComponent, {
        disableClose: true,
        panelClass: 'transparent-dialog',
      });
       this.holidayService.saveHoliday(saveApiData).subscribe({
        next: (data: any) => {
          if (data.status === 201) {
            this.dialogRef.close('success');
            if(comparePlanDate){
              this.planningDataService.setHolidayApiCallData(true)
            }
            addSpinnerRef.close();
          }
        },
        error: (error: any) => {
          addSpinnerRef.close();
        },
      });
    } else if (this.editFormData.buttonName === 'Update') {
      const editSpinnerRef = this.dialog.open(SpinnerComponent, {
        disableClose: true,
        panelClass: 'transparent-dialog',
      });
      this.holidayService
        .updateHoliday(this.editFormData.editData.holidayId, saveApiData)
        .subscribe({
        next: (data: any) => {
          if (data.status === 204) {
            editSpinnerRef.close();
            this.dialogRef.close('success');
            if(comparePlanDate){
              this.planningDataService.setHolidayApiCallData(true)
            }
          }
        },
        error: (error: any) => {
          editSpinnerRef.close();
        },
      });
    }
  }

  getReadableDateFormat(date: any) {
    const startDate = moment(date).toDate();
    const formattedDate = moment(startDate).format('DD.MM.YYYY');
    return formattedDate;
  }

  getFormDateFormat(date: any) {
    const startDate = moment(date).toDate();
    const formattedDate = moment(startDate).format('YYYY-MM-DD');
    return formattedDate;
  }

  editDateFormat(dateValue: any) {
    const dateObject = moment(dateValue, 'DD.MM.YYYY');
    // Extract date, month, and year
    const date = dateObject.date(); // Day of the month (25)
    const month = dateObject.month(); // Month (0-indexed, so add 1 to get December as 12)
    const year = dateObject.year(); // Year (2024)
    return [year, month, date];
  }
  editForm() {
    if (this.editFormData.editData.holidayDuration) {
      this.startTimeControl?.clearValidators();
      this.startTimeControl?.updateValueAndValidity();
      this.endTimeControl?.clearValidators();
      this.endTimeControl?.updateValueAndValidity();
    }
    const startDate = this.editDateFormat(this.editFormData.editData.startDate);
    this.startAtDate = new Date(startDate[0], startDate[1], startDate[2]);
    this.selectedDate = new Date(startDate[0], startDate[1], startDate[2]);
    const endDate = this.editDateFormat(this.editFormData.editData.endDate);
    this.endAtDate = new Date(endDate[0], endDate[1], endDate[2]);
    this.selectedEndDate = new Date(endDate[0], endDate[1], endDate[2]);
    this.createHolidaysForm.patchValue({
      name: this.editFormData.editData.name,
      holidayType: this.editFormData.editData.holidayDuration,
      startDate: this.editFormData.editData.startDate,
      // startTime: this.editFormData.editData.startTime,
      endDate: this.editFormData.editData.endDate,
      // endTime: this.editFormData.editData.endTime,
    });
    this.editStartDateValue=this.editFormData.editData.startDate
    this.editEndDateValue=this.editFormData.editData.endDate
    this.changeStart=false;
    this.changeEnd=false;
    this.initialFormValue = this.createHolidaysForm.getRawValue() as HolidayFormValue;
    this.isAvailable = this.editFormData.editData.isAvailable;
  }

  formatDate(dateString: string): string {
    // Parse the date string and format it as 'yyyy-MM-dd'
    const parsedDate = new Date(
      dateString.replace(/(\d{2}).(\d{2}).(\d{4})/, '$3-$2-$1')
    );
    return this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
  }

  onNoClick() {
    this.dialogRef.close();
  }

  cancelForm() {
    this.alertUser();
  }

  alertUser() {
    if (this.createHolidaysForm.dirty) {
      this.showWarningMessage = true;
      this.showWarningMessageDialog();
    } else {
      this.onNoClick();
    }
  }

  showWarningMessageDialog() {
    const dialogRef: MatDialogRef<PromptDialogComponent> = this.dialog.open(
      PromptDialogComponent,
      {
        width: '536px',
        height: '338px',
        disableClose: true,
        data: {
          iconName: 'info',
          title: 'prompt_dialog.title',
          message: 'prompt_dialog.content',
          buttons: ['prompt_dialog.back_btn', 'prompt_dialog.ok_btn'],
          buttonName: ['Back', 'OK'],
        },
      }
    );
    dialogRef.componentInstance.buttonClicked.subscribe(
      (buttonName: string) => {
        if (buttonName === 'OK') {
          dialogRef.close();
          this.onNoClick();
        } else if (buttonName === 'Back') {
          dialogRef.close();
        }
      }
    );
  }

  adjustTimeFormatForEditForm(editTime: string): string {
    const is12HourFormat = /[ap]m/i.test(editTime);

    // Get the locale-specific time format
    const localeFormat = moment.localeData().longDateFormat('LT');

    if (is12HourFormat) {
      // Convert 12-hour format to 24-hour format
      return moment(editTime, 'h:mm A').format('HH:mm');
    } else {
      // Convert 24-hour format to 12-hour format
      return moment(editTime, 'HH:mm').format(localeFormat);
    }
  }

  onToggleChange(event: any) {
    this.isAvailable = event;
    if (this.editFormData.editData) {
      this.createHolidaysForm.markAsDirty();
    }
  }

  checkIfSaveShouldBeDisabled(): void {
    const startDateStr = this.createHolidaysForm.get('startDate')?.value;
    const endDateStr = this.createHolidaysForm.get('endDate')?.value;

    // // Do not proceed unless both dates are set
    if (!startDateStr || !endDateStr) {
      return;
    }

    const selectedStartDate = this.parseDateFromString(startDateStr);
    const selectedEndDate = this.parseDateFromString(endDateStr);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!selectedStartDate || !selectedEndDate)  {
      return;
    }

    this.isSaveDisabled = selectedStartDate < today || selectedEndDate < today;
    
  }

  parseDateFromString(dateStr: string): Date | null {
    const [day, month, year] = dateStr.trim().split('.');
    if (!day || !month || !year) return null;

    const date = new Date(+year, +month - 1, +day);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  checkFormModified(): boolean {
    if (!this.initialFormValue) return false;
    const currentValue = this.createHolidaysForm.getRawValue() as HolidayFormValue;

     if (!this.editMode) {
      const startChanged = !!currentValue.startDate && currentValue.startDate !== this.initialFormValue.startDate;
      const endChanged = !!currentValue.endDate && currentValue.endDate !== this.initialFormValue.endDate;

      return startChanged || endChanged;
    }

    // Edit mode: check if any value changed
    return (Object.keys(currentValue) as (keyof HolidayFormValue)[]).some(key => {
      const current = currentValue[key];
      const initial = this.initialFormValue[key];

      if (current === null || current === undefined) return initial !== null && initial !== undefined;
      if (initial === null || initial === undefined) return current !== null && current !== undefined;

      return current.toString().trim() !== initial.toString().trim();
    });
  }
}
